import PropTypes from 'prop-types';

import { CustomSkeleton } from 'src/components/CustomSkeleton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { BrandVoiceLanguageTag } from '../BrandVoiceLanguageTag';

import { useStyles } from './useStyles';

export const BrandVoiceTitle = ({ brandVoice, title }) => {
  const styles = useStyles();

  return (
    <CustomTypography
      className={styles.root}
      variant={TYPOGRAPHY_VARIANT.h2}
    >
      {brandVoice ? (
        <>
          {brandVoice.name} <BrandVoiceLanguageTag brandVoiceLanguage={brandVoice.language} />
        </>
      ) : (
        <CustomSkeleton
          variant="text"
          width={200}
        />
      )}

      <span>/ {title}</span>
    </CustomTypography>
  );
};

BrandVoiceTitle.propTypes = {
  brandVoice: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    language: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
};
BrandVoiceTitle.defaultProps = {
  brandVoice: null,
};
